// client/src/components/icons/MicrosoftLogo.tsx
interface MicrosoftLogoProps {
  className?: string;
  size?: number;
}

// Official Microsoft four-square mark. Decorative — aria-hidden.
export function MicrosoftLogo({ className, size = 20 }: MicrosoftLogoProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 23 23"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="1" y="1" width="10" height="10" fill="#F25022" />
      <rect x="12" y="1" width="10" height="10" fill="#7FBA00" />
      <rect x="1" y="12" width="10" height="10" fill="#00A4EF" />
      <rect x="12" y="12" width="10" height="10" fill="#FFB900" />
    </svg>
  );
}
